var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackWhiteLightBlueBgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6343 11.3483C18.1324 10.8702 18.9236 10.8863 19.4017 11.3843C19.9461 11.9514 19.75 12.75 19.365 13.1524C17.6183 14.8385 15.8731 16.5851 14.3769 18.5L29.75 18.5C30.4404 18.5 31 19.0596 31 19.75C31 20.4404 30.4404 21 29.75 21L14.3769 21C15.8746 22.9168 17.6187 24.6619 19.3657 26.3483C19.8637 26.8264 19.8798 27.6177 19.4017 28.1157C18.9236 28.6137 18.1318 28.6293 17.6338 28.1513C15.7281 26.3119 13.8316 24.4235 12.2301 22.3095C11.684 21.5886 10.9999 20.6993 10.9999 19.75C10.9999 18.8007 11.684 17.9114 12.2301 17.1905C13.8273 15.0823 15.7354 13.181 17.6343 11.3483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackWhiteLightBlueBgRounded);
export default __webpack_public_path__ + "static/media/arrowBackWhiteLightBlueBgRounded.30ed218ac8c0319085fd149883d333ef.svg";
export { ForwardRef as ReactComponent };